import { render, staticRenderFns } from "./Standinfo.vue?vue&type=template&id=e68e8e3a"
import script from "./Standinfo.vue?vue&type=script&lang=js"
export * from "./Standinfo.vue?vue&type=script&lang=js"
import style0 from "./Standinfo.vue?vue&type=style&index=0&id=e68e8e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports